import './GetTheAppPage.css';
import appleStoreQRCode from "../../asserts/appleStoreQRCode.png"
export const GetTheAppPage = () => {


    return (
        <div className="get_the_app">
            <img className="qr_code_apple" src={appleStoreQRCode} alt="Open in App Store" />
            <a
                href="https://apps.apple.com/us/app/dors/id6744307960"
                target="_blank"
                rel="noopener noreferrer"
                className="apple_store_url"
            >
                <h2>Scan to download DORS app in Apple Store</h2>
            </a>
        </div>
    );
}
